import ReactFinalForm from 'components/form/ReactFinalForm';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { IMedicalServiceEtlField } from 'interfaces';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import { medicalServiceEtlFieldService } from 'services/api/MedicalServiceEtlFieldService';
import { useEffect, useState } from 'react';

interface MedicalServiceEtlFieldFormProps {
  transcode: IMedicalServiceEtlField;
  onSubmit: any;
}

export interface FieldChoice {
  code: string;
  description: string;
}

function MedicalServiceEtlFieldForm(props: MedicalServiceEtlFieldFormProps) {
  const { t } = useTranslation();
  const { transcode, onSubmit } = props;
  const [fields_choices, setFields_choices] = useState([]);
  useEffect(() => {
    medicalServiceEtlFieldService.getChoices().then((res) => {
      setFields_choices(
        res.data.reduce((acc, curr) => {
          acc.push({ code: curr[0], description: curr[1] });
          return acc;
        }, [])
      );
    });
  }, []);

  return (
    <div>
      {transcode && (
        <ReactFinalForm onSubmit={onSubmit} edit={!!transcode.id}>
          <div className="flex flex-wrap">
            <div className="w-full md:w-1/3 p-0 md:pr-4">
              <IdentityField
                name="field_to"
                component={AutocompleteAdapter}
                label={t('global.field_to')}
                options={fields_choices}
                optionValue="code"
                optionLabel="description"
                type="text"
                required
                submitObject
              />
            </div>
            <div className="w-full md:w-1/3 p-0 md:pr-4">
              <IdentityField
                name="field_from"
                component={TextFieldAdapter}
                label={t('global.field_from')}
                type="text"
                required
              />
            </div>
            <div className="w-full md:w-1/3 ">
              <IdentityField
                name="transcode"
                component={TextFieldAdapter}
                label={t('global.transcode')}
                placeholder={t('global.transcode')}
                type="text"
              />
            </div>
          </div>
        </ReactFinalForm>
      )}
    </div>
  );
}

export default MedicalServiceEtlFieldForm;
